import React from 'react';
import { AxiosError } from 'axios';
import { SnackbarProvider, useSnackbar as useNotistackSnackbar } from 'notistack';
import { MAX_TOASTS, ToastContextInterface, ToastProviderProps } from './interface';
import { getErrorMessage } from './util';

const ToastProvider = ({ children }: ToastProviderProps) => (
  <SnackbarProvider
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    hideIconVariant
    maxSnack={MAX_TOASTS}
  >
    {children}
  </SnackbarProvider>
);

const useToast = () => {
  const { enqueueSnackbar } = useNotistackSnackbar();
  const toast: ToastContextInterface = {
    info: (message: string) => enqueueSnackbar(message),
    success: (message: string) => enqueueSnackbar(message, { variant: 'success' }),
    error: (error: string | Error | AxiosError) =>
      enqueueSnackbar(
        getErrorMessage(error),
        { variant: 'error' },
      ),
    warning: (message: string) => enqueueSnackbar(message, { variant: 'warning' }),
    remove: () => { },
  }
  return toast;
};

export { ToastProvider, useToast };
